import md5 from 'js-md5'

export interface UpyunSignatureOptions {
    dirUrl?: string // 文件目录地址
}
const upyunSignature = (options?: UpyunSignatureOptions) => {
    let policy = window.btoa(JSON.stringify({
        'bucket': 'ai-files',
        'content-length-range': '0,10240000000', //文件大小限制
        'save-key': '/' + (options?.dirUrl || '') + '{filemd5}{.suffix}', //文件路径
        'expiration': Math.floor(new Date().getTime() / 1000) + 86400 //过期时间
    }))
    
    let signature = md5(policy + '&sek7H0jhaxyAVHox7UeMernjtqQ=').toString() //此处文件密钥前要添加&符号，容易出错

    return {
        policy: policy,
        signature: signature
    }
}

export default upyunSignature